import { gsap } from "gsap"
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'
import { breakpoint } from '../utilities/screen_setup'

let rafPath, pathComplete = !1, pathUncomplete = !0, old = ''

function rafSvgPath () {

  if ($('#circuit-path').length) {
    rafPath = requestAnimationFrame(rafSvgPath)
    var e = (.5 * window.innerHeight - document.querySelector('.path').getBoundingClientRect().top) / document.querySelector('#circuit-path').getBoundingClientRect().height
      , t = 8800 - 8800 * e
    e != old && document.querySelector('.path').getBoundingClientRect().top < .5 * window.innerHeight && document.querySelector('.path').getBoundingClientRect().bottom >= .1 * window.innerHeight ? (old = e,
    pathUncomplete && (pathUncomplete = !1),
    pathComplete && (pathComplete = !1),
      gsap.set('#circuitMask', {
        strokeDashoffset: t
      }),
      gsap.set('#current-pos', {
        motionPath: {
          path: '#base-path',
          end: e,
          align: '#base-path',
          immediateRender: !0,
          offsetX: -28,
          offsetY: -28
        }
      })) : document.querySelector('.path').getBoundingClientRect().bottom < .1 * window.innerHeight && 0 == pathComplete ? (old = e, pathComplete = !0,
      gsap.set('#circuitMask', {
        strokeDashoffset: 0
      })) : document.querySelector('.path').getBoundingClientRect().top > .5 * window.innerHeight && 0 == pathUncomplete && (old = e, pathUncomplete = !0,
      gsap.set('#circuitMask', {
        strokeDashoffset: 8800
      }),
      gsap.set('#current-pos', {
        motionPath: {
          path: '#base-path',
          end: 0,
          align: '#base-path',
          immediateRender: !0,
          offsetX: -28,
          offsetY: -28
        }
      }))
  }

}

function disableRafSvgPath () {
  cancelAnimationFrame(rafPath)
}

if (breakpoint('full') > breakpoint('md')) {

  let rafPathTriggers = $('.block-learning-cycle')
  rafPathTriggers.each(function (e) {
    ScrollTrigger.create({
      trigger: this,
      start: 'top center',
      end: '+=110% center',
      onEnter: rafSvgPath,
      onLeave: disableRafSvgPath,
      onEnterBack: rafSvgPath,
      onLeaveBack: disableRafSvgPath,
      //markers: true
    })
  })

}
